// extracted by mini-css-extract-plugin
export default {"main":"Styles_main__lYYTZ","mainContent":"Styles_mainContent__zvMnG","closeSidebar":"Styles_closeSidebar__GCaoY"};